import { adminEn } from "./admin";

const en = {
  ...adminEn,
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.switch": "Change language",

  "brand.name": "Trimr",

  "nav.home": "Home",
  "nav.contact": "Contact",
  "nav.privacy": "Privacy policy",
  "nav.login": "Log in",
  "nav.signup": "Get started",
  "nav.myLinks": "My links",
  "nav.signOut": "Sign out",
  "nav.admin": "Admin",
  "nav.backHome": "Back to home",

  "home.seo.title": "Trimr — Make your links short and easy to share",
  "home.seo.description":
    "Turn any long link into a short trimr.cc link in seconds. Add a password if you need one and see how many times it was visited.",
  "home.seo.keywords":
    "short link, url shortener, trimr, custom link, password protected link",
  "home.hero.title": "Make your links short and easy to share",
  "home.hero.text":
    "Turn any long link into a short one in seconds. Add a password if you need one.",
  "home.hero.placeholder": "Paste your long link here…",
  "home.cta.dashboard": "Open my dashboard",
  "home.cta.first": "Shorten it",
  "home.cta.haveAccount": "I already have an account",
  "home.feature.code.title": "Custom codes",
  "home.feature.code.text":
    "Pick the ending of your link so it stays memorable, or let us generate one for you.",
  "home.feature.stats.title": "Click count",
  "home.feature.stats.text":
    "See how many times your link was visited, and from where.",
  "home.feature.lock.title": "Password protection",
  "home.feature.lock.text":
    "Add a password: visitors have to type it before being redirected.",
  "home.footer.rights": "All rights reserved",

  "auth.seo.description": "Log in to Trimr to create and manage your short links.",
  "auth.login.title": "Welcome back!",
  "auth.login.subtitle": "Log in to find your links.",
  "auth.signup.title": "Create your account",
  "auth.signup.subtitle": "It only takes seconds to create your first link.",
  "auth.email": "Email address",
  "auth.password": "Password",
  "auth.submit.login": "Log in",
  "auth.submit.signup": "Create my account",
  "auth.emailSent":
    "A confirmation email has just been sent to {email}. Click the link inside to activate your account.",
  "auth.backToLogin": "Back to log in",
  "auth.haveAccount": "Already registered?",
  "auth.noAccount": "No account yet?",
  "auth.error.emailTaken": "This email address is already in use.",
  "auth.error.badCredentials": "Incorrect email or password.",

  "dash.seo.title": "My links",
  "dash.seo.description": "Manage your short links and see their click counts.",
  "dash.title": "My links",
  "dash.create.title": "Create a new link",
  "dash.create.description":
    "Paste your long link. Everything else is optional.",
  "dash.field.target": "Destination address",
  "dash.field.code": "Custom code (optional)",
  "dash.field.title": "Internal name (optional)",
  "dash.field.password": "Password (optional)",
  "dash.field.password.placeholder": "4 characters minimum",
  "dash.field.code.placeholder": "summer-sale",
  "dash.field.title.placeholder": "Summer campaign",
  "dash.create.submit": "Shorten it →",
  "dash.search": "Search your links…",
  "dash.empty": "No links yet — create your first one above and it will show up here.",
  "dash.loadError": "Your links could not be loaded.",
  "dash.created": "Link created.",
  "dash.copied": "Link copied.",
  "dash.copyFailed": "Copying failed.",
  "dash.deleted": "Link deleted.",
  "dash.confirmDelete": "Permanently delete the link /{code}?",
  "dash.badge.protected": "Protected",
  "dash.badge.disabled": "Disabled",
  "dash.toggle.aria": "Enable or disable the link",
  "dash.active": "Active",
  "dash.delete": "Delete",
  "dash.copy": "Copy",
  "dash.stats": "View clicks",
  "dash.clicks": "{count} clicks",
  "dash.clicks_one": "{count} click",

  "detail.seo.title": "Click count",
  "detail.seo.description": "Click details for a short link.",
  "detail.back": "Back to my links",
  "detail.notFound": "This link cannot be found.",
  "detail.copyShort": "Copy short link",
  "detail.total": "{count} clicks in total",
  "detail.total_one": "{count} click in total",
  "detail.noClicks": "No clicks in the last 30 days.",
  "detail.statsError": "Click details are unavailable right now.",
  "detail.countries": "Countries",
  "detail.devices": "Devices",
  "detail.referrers": "Sources",
  "detail.noData": "No data.",
  "detail.chart.clicks": "clicks",
  "preview.title": "Share preview",
  "preview.refresh": "Refresh preview",
  "preview.refreshed": "Preview refreshed.",
  "preview.refreshError": "The preview could not be refreshed.",
  "preview.unavailable": "Preview unavailable for this site",
  "preview.showImage": "Thumbnail in the share preview",
  "preview.showImage.help":
    "When off, the WhatsApp/Facebook/Discord preview shows only the title and the domain.",
  "preview.showImage.saved": "Share preview updated.",
  "preview.showImage.error": "The change could not be saved.",
  "preview.style.label": "Share preview style",
  "preview.style.help":
    "Messaging apps decide the final size and may keep an older preview in their cache.",
  "preview.style.standard": "Standard image",
  "preview.style.standard.help": "Use the destination image or a Trimr fallback.",
  "preview.style.video": "Video-style image",
  "preview.style.video.help": "Show a large image with a play button. It opens the link; it does not play inline.",
  "preview.style.none": "No image",
  "preview.style.none.help": "Show only the title, description, and domain.",
  "preview.style.saved": "Share preview style updated.",


  "redirect.seo.title": "Redirecting",
  "redirect.seo.description": "Opening a short link.",
  "redirect.loading": "Taking you there…",
  "redirect.inactive.title": "This link is no longer active",
  "redirect.inactive.text":
    "The person who created it has switched it off. You can ask them for a new one.",
  "redirect.password.title": "This link is protected",
  "redirect.password.named": "“{title}” is protected by a password.",
  "redirect.password.generic": "Enter the password to continue.",
  "redirect.password.label": "Password",
  "redirect.password.submit": "Continue",
  "redirect.password.wrong": "Incorrect password.",

  "notfound.seo.title": "404 - Page not found",
  "notfound.seo.description": "The page you are looking for does not exist or has been moved.",
  "notfound.title": "Page not found",
  "notfound.text": "Oops! We could not find that page. It may have been moved or the link is mistyped.",

  "contact.seo.title": "Contact",
  "contact.seo.description":
    "A question about Trimr? Write to us at hello@trimr.cc, we answer quickly.",
  "contact.title": "Contact us",
  "contact.subtitle":
    "Any questions or ideas? Get in touch and we will get back to you as soon as possible. You can also email us at hello@trimr.cc.",
  "contact.name": "Full name",
  "contact.name.placeholder": "John Smith",
  "contact.email": "Email",
  "contact.email.placeholder": "john.smith@example.com",
  "contact.subject": "Subject",
  "contact.subject.placeholder": "Subject of your message",
  "contact.message": "Message",
  "contact.message.placeholder": "Your message...",
  "contact.send": "Send message",
  "contact.sending": "Sending...",
  "contact.security": "Security check",
  "contact.error.security": "Please complete the security check.",
  "contact.success": "Message sent. We will reply shortly.",
  "contact.error.send": "The message could not be sent. Please try again.",
  "contact.validation.name.required": "Name is required",
  "contact.validation.name.max": "Name cannot exceed 100 characters",
  "contact.validation.email.invalid": "Invalid email",
  "contact.validation.email.max": "Email cannot exceed 255 characters",
  "contact.validation.subject.required": "Subject is required",
  "contact.validation.subject.max": "Subject cannot exceed 200 characters",
  "contact.validation.message.min": "Message must be at least 10 characters",
  "contact.validation.message.max": "Message cannot exceed 2000 characters",

  "privacy.seo.title": "Privacy policy",
  "privacy.seo.description":
    "What information Trimr keeps when you create a short link or someone visits it, and for how long.",
  "privacy.seo.keywords": "privacy, personal data, GDPR, short links, trimr",
  "privacy.title": "Privacy policy",
  "privacy.subtitle": "How Trimr handles your information, in plain language",
  "privacy.s1.title": "1. Data we process",
  "privacy.s1.account.label": "Account:",
  "privacy.s1.account.text":
    "your email address and your sign-in dates, to secure access to your links.",
  "privacy.s1.links.label": "Links created:",
  "privacy.s1.links.text":
    "the destination address, the chosen short code, the optional title, any expiry date and, if you set one, the encrypted fingerprint of the link password. The password itself is never stored in clear text.",
  "privacy.s1.clicks.label": "Clicks:",
  "privacy.s1.clicks.text":
    "each time a short link is opened we record the date, the IP address, the estimated country and city, the internet provider and network, the device, operating system and browser, the browser language, the originating page (referrer) and a visitor identifier. That identifier is produced by our processor Fingerprint (fingerprint.com) and lets us tell visitors apart and detect abuse. These technical records are kept for 12 months, then deleted automatically, and are visible only to the site administrators.",
  "privacy.s1.security.label": "Site security:",
  "privacy.s1.security.text":
    "technical logs (IP address, browser, pages viewed, sign-in attempts) are kept to detect bots and abuse.",
  "privacy.s2.title": "2. Why this data",
  "privacy.s2.i1": "Making short link redirection work — delivery of the service.",
  "privacy.s2.i2":
    "Showing link creators how many times their link was visited — legitimate interest in knowing the reach of their own links.",
  "privacy.s2.i3":
    "Protecting the service against bots, abuse and malicious content — legitimate interest in security.",
  "privacy.s2.note":
    "Click counts are grouped together: they never allow the people opening a link to be identified by name.",
  "privacy.s3.title": "3. Retention periods",
  "privacy.s3.i1": "Account and links: as long as your account exists.",
  "privacy.s3.i2":
    "Click details: kept for the lifetime of the link; deleting a link also deletes its clicks.",
  "privacy.s3.i3": "Technical security logs: limited period, purged automatically.",
  "privacy.s4.title": "4. Recipients",
  "privacy.s4.text":
    "Data is never sold. It is processed by technical providers acting on our behalf: hosting and database, transactional email delivery, bot protection and a service estimating location from the IP address.",
  "privacy.s5.title": "5. Your rights",
  "privacy.s5.p1":
    "Under the GDPR you have the right to access, correct, erase, restrict and object to the processing of your data, as well as a right to data portability. You can delete a link and its click history yourself from your dashboard.",
  "privacy.s5.p2.before": "To exercise your rights, email privacy@trimr.cc or use the",
  "privacy.s5.p2.link": "Contact",
  "privacy.s5.p2.after": "page. You may also lodge a complaint with your data protection authority.",
  "privacy.s6.title": "6. Cookies",
  "privacy.s6.text":
    "Trimr uses no advertising cookies and shares nothing with marketing companies. Only strictly necessary elements are used: keeping your session while you are signed in, and protection against bots.",
};

export default en;
export type TranslationKey = keyof typeof en;
